module.exports = __webpack_public_path__ + "img/weixin1.a7237661.png";